/**
 * fetch resiliente a blips transitórios de rede / Service Worker.
 *
 * Contexto: o Service Worker é network-first e, num blip transitório (rajada de
 * requisições concorrentes no mount), RESOLVE com um Response 503 {offline:true}
 * em vez de rejeitar. Proxies/Cloudflare podem responder 403/429 (desafio) ou um
 * HTML em vez de JSON. Sem tratamento, isso fazia listas/estatísticas piscarem
 * vazias/zeradas. Estas funções tornam o carregamento imune a esses transitórios.
 */

const RETRY_STATUSES = [403, 408, 429, 502, 503, 504];
const delay = (ms) => new Promise((r) => setTimeout(r, ms));

const isRetryable = (res) =>
  RETRY_STATUSES.includes(res.status) || res.headers.get('X-Offline-Mode') === 'true';

/**
 * Faz fetch e retorna o JSON parseado em caso de sucesso, ou `null` se esgotar
 * as tentativas (offline real / desafio persistente). Transitórios (503/403/429,
 * X-Offline-Mode, ou resposta HTML que falha no .json()) são reexecutados com backoff.
 *
 * @param {string} url
 * @param {object} options  opções do fetch (headers, method, body...)
 * @param {number} attempts número de tentativas (default 4)
 * @returns {Promise<any|null>}
 */
export async function fetchJsonResilient(url, options = {}, attempts = 4) {
  const opts = { cache: 'no-store', ...options };
  for (let i = 0; i < attempts; i++) {
    try {
      const res = await fetch(url, opts);
      if (res.ok) {
        // Pode lançar SyntaxError se vier HTML (ex: desafio) → cai no catch e reexecuta
        return await res.json();
      }
      if (isRetryable(res) && i < attempts - 1) {
        await delay(400 * (i + 1));
        continue;
      }
      return null; // erros não-transitórios (401/404/422...) ou última tentativa
    } catch (e) {
      if (i < attempts - 1) {
        await delay(400 * (i + 1));
        continue;
      }
      return null;
    }
  }
  return null;
}

export default fetchJsonResilient;
